export const COLOR_ATTRIBUTE = 'DEF_Color';
export const CAPACITY_ATTRIBUTE = 'DEF_Capacity';
export const GIFT_CARD_VALUES_ATTRIBUTE = 'DEF_Value';
export const COUNTRY_ATTRIBUTE = 'DEF_Country';

const getItems = (catalogEntryView: any[]): any[] => {
	return catalogEntryView[0].items.map((item: any) => {
		const attributes = item.attributes ?? [];
		return {
			uniqueID: item.uniqueID,
			attributes,
			id: item.id,
			partNumber: item.partNumber,
			colorId: attributes.find((attr: any) => attr.identifier === COLOR_ATTRIBUTE)?.values[0].id,
			capacityId: attributes.find((attributte: any) => attributte.identifier === CAPACITY_ATTRIBUTE)?.values[0]
				?.id,
			valueId: attributes.find((attr: any) => attr.identifier === GIFT_CARD_VALUES_ATTRIBUTE)?.values[0].id,
			countryId: attributes.find((attr: any) => attr.identifier === COUNTRY_ATTRIBUTE)?.values[0].id,
			fullImage: item.fullImage,
			thumbnail: item.thumbnail,
			shortDescription: item.shortDescription,
		};
	});
};

const model: types.models.InputModel = {
	_contents: 'response.contents',
	items: (model: any) => {
		if (model._contents[0].items) {
			return getItems(model._contents);
		}
	},
};

export default model;
